import * as React from 'react';
import { Grid, Typography } from '@mui/material';
import { TimePicker } from '@components/timePicker/TimePicker';
import { DatePicker } from '@components/datePicker';

interface DateTimePickerProps {
  placeholder?: string;
  disableFuture?: boolean;
  id?: string;
  label?: string;
  onChange: (dateTime: Date | null) => void;
  defaultDate?: Date;
}
export const DateTimePicker = ({
  onChange,
  label,
  id = 'dateTimePicker',
  placeholder,
  disableFuture,
  defaultDate,
}: DateTimePickerProps) => {
  const [selectedDate, setSelectedDate] = React.useState<Date | null>(defaultDate ?? null);

  const handleChangeDate = (dateTime: Date | null) => {
    setSelectedDate(dateTime);
    onChange(dateTime);
  };

  return (
    <Grid
      container
      sx={{
        width: '100%',
      }}
    >
      <Grid size={{ xs: 12 }}>
        <Typography variant='caption' sx={{ marginBottom: '6px' }}>
          {label ?? 'Date'}
        </Typography>
      </Grid>
      <Grid
        container
        size={{ xs: 12 }}
        spacing={1}
        sx={{
          flexDirection: 'row',
        }}
      >
        <Grid>
          <DatePicker
            value={selectedDate}
            disableFuture={disableFuture}
            textFieldProps={{
              placeholder: placeholder ?? 'MM/DD/YYYY',
            }}
            data-testid={`${id}-date-picker`}
            onAccept={handleChangeDate}
            onChange={(value) => {
              handleChangeDate(value);
            }}
          />
        </Grid>
        <Grid sx={{ width: '150px' }}>
          <TimePicker
            value={selectedDate}
            onChange={(v, e) => !e.validationError && handleChangeDate(v)}
            textFieldProps={{
              placeholder: 'hh:mm aa',
            }}
            data-testid={`${id}-time-picker`}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
